import { render } from "./SelecionarCategoriaPlanoConta.vue?vue&type=template&id=50b0554c&ts=true"
import script from "./SelecionarCategoriaPlanoConta.vue?vue&type=script&lang=ts"
export * from "./SelecionarCategoriaPlanoConta.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__